import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import PaymentIntervalForm from '../../../components/forms/PaymentIntervalForm';
import { useCreatePaymentInterval } from '../../../hooks/usePaymentIntervalApi';
import { useNavigate } from 'react-router-dom';
import { PaymentIntervalDTO } from '../../../services/apiClient';

const PaymentIntervalCreate: React.FC = () => {
  const createMutation = useCreatePaymentInterval();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Payment Intervals', href: '/admin/paymentintervals' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: PaymentIntervalDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/paymentintervals');
    } catch (error) {
      console.error('Error creating PaymentInterval:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/paymentintervals"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.PaymentInterval.Edit"
    >
        <PaymentIntervalForm
          initialValues={{} as PaymentIntervalDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/paymentintervals')}
        />
    </AdminLayout>
  );
};

export default PaymentIntervalCreate;
